import React from "react";
import { FaInbox, FaInstagram, FaTiktok, FaTwitch, FaYoutube } from "react-icons/fa";
import "../CSS/SocialLinks.css";

const socials = [
  { href: "https://www.tiktok.com/@haloextravalanza", icon: <FaTiktok/>,  label: "Tiktok" },
  { href: "https://www.twitch.tv/haloextravalanza", icon: <FaTwitch />,   label: "Twitch" },
  { href: "https://www.youtube.com/@haloextravalanza", icon: <FaYoutube/>,  label: "Youtube" },
  { href: "https://www.instagram.com/haloextravalanza/", icon: <FaInstagram/>,  label: "Instagram" },
  { href: "mailto:HALOEXTRAVALANZA@gmail.com", icon: <FaInbox/>,  label: "Email" },
];

export default function SocialLinks() {
  return (
    <div className="social-links">
      {socials.map(({ href, icon, label }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
        >
          {icon}
        </a>
      ))}
    </div>
  );
}
